import { createAsyncThunk } from "@reduxjs/toolkit";

import { getPdfData, postData, postExcelDownload } from "../../../services";
import { fetchDataAxios } from "../../../apiConfig";

export const getAbhaCardThunk = createAsyncThunk(
  "/abhacard",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await getPdfData(`/profile/account/abha-card`, {
        ...productRequest,
      });
      console.log("resss", result.data);
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err });
    }
  }
);

export const getAbhaCardPhrThunk = createAsyncThunk(
  "/abhacard",
  async (productRequest, { rejectWithValue }) => {
    try {
      const result = await getPdfData(`/phr/web/login/profile/abha/phr-card`, {
        ...productRequest,
      });
      console.log("resss", result.data);
      return result.data;
    } catch (err) {
      return rejectWithValue({ error: err });
    }
  }
);
